/**
 * This file serves as a proxy to avoid circular dependencies between apiClient and apiConfig
 * It re-exports the apiClient instance for use throughout the application
 */
import apiClient from './apiClient';

export default apiClient;
